<template>
    <div class="supply_wrap2">
        <div class="search-wrap" :class="{'dropdown':!dropdown}" :style="{height: H}" id="search_top_con">
            <!-- 搜索条件 -->
            <div style=" margin: 0 auto;">
                <div class="search-box1">
                    <!-- <div class="suppldetaibox-top">
                        <div style="width:94px ;">
                            <el-select v-model="form.status" class="mySelect" popper-class="wentipingSelectPopper" @change="handleSelectChange" style="width: 94px; margin-right: 20px;">
                                <el-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                            </el-select>
                        </div>
                        <div style="flex: 1;">
                            <div v-if="form.status == 0" style="display:flex ; align-items: center;">
                                <el-input style="position:relative ;" v-model="tempform.isbns" placeholder="可输入多个ISBN"
                                    readonly @click.native="multiplePop('ISBN','isbns')">
                                </el-input>
                                <i v-if="tempform.isbns" class="el-icon-circle-close circleclose"
                                    style="position: absolute ; right: 70px;" @click="clearValue('isbns')"></i>
                            </div>
                            <div v-if="form.status == 1" style="display:flex; align-items: center;">
                                <el-input v-model="tempform.bookname" placeholder="请输入书名" clearable>
                                </el-input>
                            </div>
                            <div v-if="form.status == 2" style="display:flex; align-items: center;">
                                <el-input placeholder="请输入作者" v-model="tempform.author" clearable>
                                </el-input>
                            </div>
                        </div>
                        <div class="titleNames"></div>
                    </div> -->
                    <el-form label-position="right" label-width="90px" :model="tempform" style="width:95%;">
                        <el-row :span="24" style="margin-top: 15px;">
                            <el-col  :span="8">
                            <el-form-item label="书名：" style="font-weight: 700; " class="labelwrap">
                                <el-input v-model="tempform.bookname" placeholder="请输入书名"style="height: 35px;" clearable>
                                </el-input>
                            </el-form-item>
                            </el-col>
                            <el-col  :span="8">
                            <el-form-item label="作者：" style="font-weight: 700; " class="labelwrap">
                                <el-input v-model="tempform.author" placeholder="请输入作者"style="height: 35px;" clearable>
                                </el-input>
                            </el-form-item>
                            </el-col>
                            <el-col  :span="8">
                                <el-form-item label="ISBN：" style="font-weight: 700; " class="labelwrap">
                                    <el-input style="position:relative ;" v-model="tempform.isbns" placeholder="可输入多个ISBN"
                                    readonly @click.native="multiplePop('ISBN','isbns')">
                                </el-input>
                                <i v-if="tempform.isbns" class="el-icon-circle-close circleclose"
                                    style="position: absolute ; right: 70px;" @click="clearValue('isbns')"></i>
                                </el-form-item>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="showpubname?'6':'8'">
                            <el-form-item label="出版社：" style="font-weight: 700; " class="labelwrap" v-if="showpubname">
                                <el-input v-model="tempform.pubname" placeholder="输入搜索条件" readonly
                                    @click.native="pubpop(tempform.pubname)" style="height: 35px;">
                                </el-input>
                                <i v-if="tempform.pubname" class="el-icon-circle-close circleclose"
                                    @click="clearValue('pubname','','pubid')"></i>
                            </el-form-item>
                        </el-col>
                            <el-col :span="showpubname?'6':'8'">
                                <el-form-item label="中图法：" style="font-weight: 700;" class="labelwrap">
                                    <el-input v-model="tempform.ztf" placeholder="选择中图分类" readonly
                                        @click.native="ztfflWindow()">
                                    </el-input>
                                    <i v-if="tempform.ztf" class="el-icon-circle-close circleclose"
                                        @click="clearValue('ztf','classifydata')"></i>
                                </el-form-item>
                            </el-col>
                            <el-col :span="showpubname?'6':'8'">
                                <el-form-item label="学科分类：" style="font-weight: 700;" class="labelwrap">
                                    <el-input v-model="tempform.subjectShow" readonly placeholder="选择学科分类"
                                        @click.native="styClass()">
                                    </el-input>
                                    <i v-if="tempform.subjectShow" class="el-icon-circle-close circleclose"
                                        @click="clearValue('subjectShow','xuekedata','xkfl')"></i>
                                </el-form-item>
                            </el-col>
                            <el-col :span="showpubname?'6':'8'">
                                <el-form-item label="大众分类：" style="font-weight: 700;" class="labelwrap">
                                    <el-input v-model="tempform.dazhongshow" placeholder="选择大众分类" readonly
                                        @click.native="pubClass()">
                                    </el-input>
                                    <i v-if="tempform.dazhongshow" class="el-icon-circle-close circleclose"
                                        @click="clearValue('dazhongshow','dazhongdata','dzfl')"></i>
                                </el-form-item>
                                 <!-- <el-form-item label="主题词：" style="font-weight: 700;" class="labelwrap">
                                    <el-input v-model="tempform.dazhongshow" placeholder="选择主题词" readonly
                                        @click.native="pubClass()">
                                    </el-input>
                                    <i v-if="tempform.dazhongshow" class="el-icon-circle-close circleclose"
                                        @click="clearValue('dazhongshow','dazhongdata','dzfl')"></i>
                                </el-form-item> -->
                            </el-col>
                        </el-row>
                        <el-row :span="24">
                            <el-col :span="9">
                                <el-form-item label="出版时间：" style="font-weight: 700;">
                                    <div style="display: flex; align-items: center;">
                                        <DatePicker type="month" placeholder="选择日期" value-format="yyyy-MM-dd"
                                            style="width: 100%;" :picker-options="startTime" v-model="tempform.pubfrom">
                                        </DatePicker>
                                        <el-col class="line" :span="4" style="text-align: center;">-</el-col>
                                        <DatePicker type="month" placeholder="选择日期" value-format="yyyy-MM-dd"
                                            style="width: 100%;" :picker-options="endTime" v-model="tempform.pubto">
                                        </DatePicker>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item label="码洋：" style="font-weight: 700;">
                                    <div style="display: flex; align-items: center;">
                                        <el-input v-model="tempform.myfrom" clearable style="width: 85px;"></el-input>
                                        <i class="font" style="font-weight: normal; font-style: normal; margin-left: 5px;">元</i>
                                        <el-col class="line" :span="4" style="text-align: center;">-</el-col>
                                        <el-input v-model="tempform.myto" clearable style="width: 85px;"></el-input>
                                        <i class="font" style="font-weight: normal; font-style: normal; margin-left: 5px;">元</i>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item label="尺寸：" style="font-weight: 700;">
                                    <div style="display: flex; align-items: center;">
                                        <el-input v-model="tempform.min" clearable style="width: 85px;"></el-input>
                                        <i class="font" style="font-weight: normal; font-style: normal; margin-left: 5px;">cm</i>
                                        <el-col class="line" :span="4" style="text-align: center;">-</el-col>
                                        <el-input v-model="tempform.max" clearable style="width: 85px;"></el-input>
                                        <i class="font" style="font-weight: normal; font-style: normal; margin-left: 5px;">cm</i>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div v-show="showAdditionalSearch" id='toggle-btn'>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="适用对象：" style="font-weight: 700;">
                                    <div class="flex-container">
                                        <div v-for="(item, index) in objArr" :key="index" class="flex-item"
                                            @click="toggleSelected1(index)"
                                            :class="{ 'flex-item-14': true, 'selected': item.selected }">
                                            {{ item.value }}
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="专题：" style="font-weight: 700;">
                                    <div class="flex-container">
                                        <div v-for="(item, index) in specialsubjectArr" :key="index" class="flex-item"
                                            @click="toggleSelected5(index)"
                                            :class="{ 'flex-item-14': true, 'selected': item.selected }">
                                            {{ item.key }}
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="装帧：" style="font-weight: 700;">
                                    <div class="flex-container">
                                        <div v-for="(item, index) in zzArr" :key="index" class="flex-item"
                                            @click="toggleSelected2(index)"
                                            :class="{ 'flex-item-14': true, 'selected': item.selected }">
                                            {{ item.value }}
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="阅读类型：" style="font-weight: 700;">
                                    <div class="flex-container">
                                        <div v-for="(item, index) in readbooktype" :key="index" class="flex-item"
                                            @click="toggleSelected3(index)"
                                            :class="{ 'flex-item-14': true, 'selected': item.selected }">
                                            {{ item.key }}
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="交付方式：" style="font-weight: 700;">
                                    <div class="flex-container">
                                        <div v-for="(item, index) in Paymentmethod" :key="index" class="flex-item"
                                            @click="toggleSelected4(index)"
                                            :class="{ 'flex-item-14': true, 'selected': item.selected }">
                                            {{ item.key }}
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="上下架状态：" style="font-weight: 700;">
                                    <div class="flex-container">
                                        <div v-for="(item, index) in listingstatus" :key="index" class="flex-item"
                                            @click="toggleSelected6(index)"
                                            :class="{ 'flex-item-14': true, 'selected': item.selected }">
                                            {{ item.key }}
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <!--  -->
                        <div class="search-btn" v-show="dropdown" >
                            <Button type="primary" size="mini" @click="onSubmit" class="submit-btn">检索</Button>
                            <Button @click.native="resetForm" size="mini"
                                class="iconfont icon-reset reset-btn">重置</Button>
                        </div>
                    </el-form>
                </div>
            </div>
            <span class="drop_btn" @click="toggleSlide(500)" id= 'toggle-btn' 
                :class="{'el-icon-top':showAdditionalSearch,'el-icon-bottom':!showAdditionalSearch}">{{showAdditionalSearch?
                '收起':'展开更多'}}检索条件</span>
        </div>
        <div>
            <div class="zjdBg" v-if="isBeat">
                <div class="zjdContent">
                    <div class="q">
                        <div class="zjd">
                            <img src="../assets/images/zjdbj.jpg" alt="">
                            <!-- <marquee class="zjdtime" direction=left>
                                活动时间为：2022年9月19日到2022年9月20日的每天上午的10点到10点10分，下午的15点到15点10分。
                            </marquee> -->
                            <!-- <div class='hdcc1'>
                                <p class='hdcc'> 活动场次</p>
                                <div v-for="(item,index) in c" :key="index">{{item.start_time}}--{{item.end_time}}</div>
                            </div> -->
                            <div class="zjdClose" @click="zjdClose">
                                <img src="../assets/zjd_img/quit.png" />
                            </div>
                            <div class="nostate" v-if="how">
                                活动还未开始敬请期待！
                            </div>
                            <div class="zjdBox" v-else style="position:absolute ; top: 0;">
                                <zjd-component :activateinfo="activateInfo" :activatesource = 'activatesource' :activateid = 'activateid'>
                                </zjd-component>
                            </div>
                            <div class="prInfo">
                                <div class="prInfo-box" >
                                    <div class="prInfo-info">中奖明细</div>
                                </div>
                                <div id="moocBox" @mouseover="stopScroll" @mouseout="startScroll">
                                    <ul id="con1">
                                        <li v-for="(item,index) in listname" :key="index"
                                            style="line-height: 40px; color: #1a0707; font-size: 14px; ">恭喜
                                            <a href="#" style="color:red;">{{item.org_name}}</a>获得<a href="#" style="color:red;">{{item.level}}</a>
                                        </li>
                                    </ul>
                                    <ul id="con2">
                                        <li v-for="(item,index) in listname" :key="index"
                                        style="line-height: 40px; color: #1a0707; font-size: 14px;">恭喜
                                        <a href="#" style="color:red;">{{item.org_name}}</a>获得<a href="#" style="color:red;">{{item.level}}</a>
                                    </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="position:absolute ; top: 230px;left: 20px;" v-if="showzajindan"  >
            <img src="../assets/pub_img/daojishuawen.png" alt="" style="width: 210px; position: relative;" >
            <div v-if="!newRecodePop" style="display: flex; justify-content: space-evenly; flex-direction: column; align-items: center; position: absolute;  top: 0px; height: 100%; width: 100%;"   >
                <div style="color: #fff;font-size: 20px;font-weight: 700;">砸金蛋,赢大礼</div>
                <div v-if="showactivity">
                    <div style="display: flex; justify-content: space-evenly; flex-direction: column; align-items: center;" v-if=" dianclose" >
                        <div style="color: #fff;font-size: 20px;font-weight: 700;">倒计时: <span style="color: #FFD700;"> {{ formattedTime  }}</span> </div>
                        <div style="color: #fff; font-size: 14px;">(退出该页面后倒计时将重置)</div>
                    </div>
                    <div style="display: flex; justify-content: space-evenly; flex-direction: column; align-items: center;"  v-else  @click="zajindan">
                         <div style="color: #fff; font-size: 20px; font-weight: 700; cursor: pointer;">
                              <span v-for="(letter, index) in text" :key="index" :style="{ animationDelay: `${index * 0.5}s` }" class="jump-text">{{ letter }}</span>
                         </div>
                    </div>
                </div>
                <div v-else>
                    <div v-if="showstart" style="display: flex; justify-content: space-evenly; flex-direction: column; align-items: center;">
                        <div style="color: #fff;font-size: 20px;font-weight: 700;">活动未开始</div>
                        <div style="color: #fff; font-size: 14px;"> 开始时间为:({{ starttimekaishi}})</div>
                    </div>
                    <div v-else>
                        <div style="color: #fff;font-size: 20px;font-weight: 700;">活动已结束</div>
                    </div>
                </div>
            </div>
            <div v-else  style="display: flex; justify-content: space-evenly; flex-direction: column; align-items: center; position: absolute;  top: 0px; height: 100%; width: 100%; "  >
                <div style="color: #fff;font-size: 20px;font-weight: 700;">砸金蛋,赢大礼</div>
                <div style="color: #fff; display: flex; justify-content:center; flex-direction: column; align-items: center; font-weight: 700;">
                <div v-if="ishuode">恭喜您获得</div>
                <div style="color: #FFD700;font-size: 18px; width: 81%;" >{{present_name}}</div>
                </div>
                <a href="javascript:;" class="bottxtx" @click="getWinning()"> <span style="color: #fff;">【领取礼品】</span></a>  
            </div>
       
    </div>
    </div>
</template>

<script>
    import { Row, Col, Form, FormItem, Input, Button, Notification, Checkbox, DatePicker, CheckboxGroup, Select, Option } from 'element-ui'
    import classifyPop from './ClassifyPop'
    import studyclass from './studyClassPop'
    import publicpop from './publicPop'
    import ZjdComponent from "./testcopy";
  import Axios from "@/api/diyaxios";
    import popup from '../common/plugin/dialog/index.js'
    import pubDialog from './pubDialog'
    import keyValuePop from './textareaDialog'
    import Cookies from 'js-cookie'
    import { insertPoint } from '@/api/insertPoints'   //添加埋点
    import {goldeggsmashingactivity,goldeggsids } from '@/api/pages'
    

    export default {
        props: ['isShowType','showpubname','activityID'],
        data() {
            let vm = this;
            return {
                showzajindan:false,   //进入倒计时的提示显示和隐藏
                showAdditionalSearch:false,
                text: "点我砸金蛋",
                dianclose:true,
                countdownTime: 180, 
                timer: null,
                startTime: null,
                pubShow: true,
                zttagShow: true,
                ztfShow: true,
                xkShow: true,
                dzShow: true,
                dropdown: true,//是否展开
                H: this.showAdditionalSearch?`650px`  : `300px`,
                // 适用对象
                objArr: [
                    { key: '', value: '全部', selected: false },
                    { key: '本科及以上', value: '本科及以上', selected: false },
                    { key: '高职', value: '高职', selected: false },
                    { key: '少儿', value: '少儿', selected: false },
                    { key: '音像电子', value: '音像电子', selected: false },
                    { key: '中职', value: '中职', selected: false },
                    { key: '职业教育', value: '职业教育', selected: false },
                    { key: '成人教育', value: '成人教育', selected: false },
                    { key: '幼儿', value: '幼儿', selected: false },
                    { key: '小学', value: '小学', selected: false },
                    { key: '初中', value: '初中', selected: false },
                    { key: '中小学', value: '中小学', selected: false },
                    { key: '高中', value: '高中', selected: false },
                    { key: '青少年', value: '青少年', selected: false },
                    { key: '通俗读物', value: '通俗读物', selected: false },
                    { key: '继续教育', value: '继续教育', selected: false }
                ],
                zzArr: [//装帧
                    { key: '', value: '平装', selected: false },
                    { key: '精装', value: '精装', selected: false },
                    { key: '线装', value: '线装', selected: false },
                    { key: '活页', value: '活页', selected: false },
                    { key: '其它', value: '其它', selected: false },
                    { key: '函装', value: '函装', selected: false },
                    { key: '盒装', value: '盒装', selected: false }
                ],
                specialsubjectArr:[
                { key: '全部', value: '', selected: false },
                { key: '精品大码洋', value: '10138', selected: false },
                { key: '博古观今', value: '10128', selected: false },
                { key: '人生智慧', value: '10129', selected: false },

                ],
                readbooktype: [//阅读类型
                    { key: '纸质书', value: '1', selected: false },
                    { key: '纸电同步', value: '5', selected: false },
                    { key: '电子书', value: '2', selected: false },
                    { key: '期刊', value: '4', selected: false },
                ],
                Paymentmethod: [//支付方式
                    { key: '全部', value: '', selected: false },
                    { key: '期货', value: '0', selected: false },
                    { key: '现货', value: '1', selected: false },
                ],
                listingstatus: [//支付方式
                    { key: '全部', value: '', selected: false },
                    { key: '上架', value: '0', selected: false },
                    { key: '下架', value: '1', selected: false },
                ],
                statusList: [
                    {
                        value: '0',
                        label: 'ISBN'
                    },
                    {
                        value: '1',
                        label: '书名'
                    },
                    {
                        value: '2',
                        label: '作者'
                    },
                ],
                form: {
                    status: '0'
                },
                tempform: {//表单信息
                    // goodstype:1,
                    isbns: null,
                    bookname: null,
                    author: null,
                    pubname: null,
                    pubid: null,
                    pubfrom: null,
                    pubto: null,
                    ztf: null,
                    subjectShow: null,
                    xkfl: null,
                    dazhongshow: null,
                    dzfl: null,
                    myfrom: null,
                    myto: null,
                    useobj: null,
                    zhuangj: null,
                    activitytag: null,
                    isaddcar: '0',
                    delivery: null,
                    goodsType: null,
                    // size: 20,
                    // current: 1
                },
                m_modal: null,
                classifydata: null,
                temp_pop: null,
                pub_pop: null,
                key_pop: null,
                savetemp_pop: null,
                sty_clsss: null,
                public_clsss: null,
                xuekedata: null,
                dazhongdata: null,
                pubObjCheck: [],//出版社选中数据
                startTime: {
                    disabledDate: time => {
                        if (vm.tempform.pubto) {
                            return (
                                time.getTime() > new Date(vm.tempform.pubto).getTime()
                            );
                        }
                    }
                },
                endTime: {
                    disabledDate: time => {
                        if (vm.tempform.pubfrom) {
                            return (
                                time.getTime() < new Date(vm.tempform.pubfrom).getTime()
                            );
                        }
                    }
                },
                listname: [],
                msg: '恭喜您中奖了',
                isBeat: false, //砸金蛋弹窗
                isAble: false, //禁用按钮
                activateInfo: "", //活动信息
                activatesource:'',
                activateid:'',
                success: "",
                istimer: null,
                ishuode:false,
                timelist: [
                    { start: "2022-09-23 15:00:00", end: "2022-09-23 15:10:00" },
                    { start: "2022-09-23 10:00:00", end: "2022-09-23 10:10:00" },

                    { start: "2022-09-22 15:00:00", end: "2022-09-22 15:10:00" },
                    { start: "2022-09-22 10:00:00", end: "2022-09-22 10:10:00" },

                    { start: "2022-09-21 15:00:00", end: "2022-09-21 15:10:00" },
                    { start: "2022-09-21 10:00:00", end: "2022-09-21 10:10:00" },

                    { start: "2022-09-20 15:00:00", end: "2022-09-20 15:10:00" },
                    { start: "2022-09-20 10:00:00", end: "2022-09-20 10:10:00" },

                    { start: "2022-09-19 15:00:00", end: "2022-09-19 18:00:00" },
                    { start: "2022-09-19 10:00:00", end: "2022-09-19 10:10:00" },
                ],
                speed: 50,
                myScroll: null,
                showToast: false, //显示中奖弹窗
                showstatus: false,  //砸金蛋状态
                //砸金蛋结果
                winResult: null,
                how: false,
                imaguls: '',
                levels: '',
                showsta: false,
                newRecodePop:false,
                present_name:'',
                huodongchangci:[],
                showactivity:false,
                showstart:false,
                starttimekaishi:'',

            }
        },
        components: {
            Row, Col, Form, FormItem, Input, Button, Notification, Checkbox, DatePicker, CheckboxGroup, Select, Option, ZjdComponent,
        },
        created() {
            this.startTime = new Date();
            // this.getWinningRecord()  // 查询个人中没中奖
            // this.getJindan()   // 查询所有中奖记录
            this.form.status = this.statusList[0].value;
            this.objArr.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.useobj = item.key
                } else {
                    item.selected = false;
                }
            });
            this.zzArr.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.zhuangj = item.key
                } else {
                    item.selected = false;
                }
            });
            this.Paymentmethod.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.delivery = item.value


                } else {
                    item.selected = false;
                }
            });
             this.listingstatus.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.delivery = item.value


                } else {
                    item.selected = false;
                }
            });
            this.readbooktype.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.goodsType = item.value

                } else {
                }
            });
            this.specialsubjectArr.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.activitytag = item.value

                } else {
                }
            });
            
        },
        mounted() {
            let vm = this
            if (vm.$route.name === "calendar") {
                vm.isAble = true;
            }
            vm.$nextTick(() => {
            const area = document.getElementById('moocBox');
            const con1 = document.getElementById('con1');
            const con2 = document.getElementById('con2');
            area.scrollTop = 0;
            con2.innerHTML = con1.innerHTML;
            vm.myScroll = setInterval(vm.scrollUp, vm.speed);
                let isType = vm.isShowType;
                for (var key in isType) {
                    vm[key] = isType[key];
                }
            })
        },
        destroyed() {
            clearInterval(this.istimer);
        },
        computed: {
           formattedTime() {
             return this.formatTime();
           },
  },
        beforeDestroy() {
            const endTime = new Date();
            const timeSpent = (endTime - this.startTime) / 1000; 
            if (timeSpent < this.countdownTime) {
                this.resetTimer();
            } else {
                console.log("User stayed on the page for 5 minutes");
            }
        },
        methods: {
            startTimer() {
                this.timer = setInterval(() => {
                    this.countdownTime--;
                    if (this.countdownTime <= 0) {
                        clearInterval(this.timer);
                        this.isBeat = true
                        this.startScroll()
                        if(this.showAdditionalSearch){
                        this.toggleSlide(500)
                        }
                    }
                }, 1000);
            },
            resetTimer() {
                clearInterval(this.timer);
                this.countdownTime = 300;
                this.startTimer();
            },
            formatTime() {
            const minutes = Math.floor(this.countdownTime / 60);
            const seconds = this.countdownTime % 60;
            return `${minutes.toString().padStart(2, '0')}分${seconds.toString().padStart(2, '0')}秒`;
            },
            stopScroll() {
                clearInterval(this.myScroll);
            },
            startScroll() {
                this.myScroll = setInterval(this.scrollUp, this.speed);
            },
            scrollUp() {
                const area = document.getElementById('moocBox');
                const con1 = document.getElementById('con1');
                const con2 = document.getElementById('con2');
                if (area.scrollTop >= con1.scrollHeight) {
                    area.scrollTop = 0;
                } else {
                    area.scrollTop++;
                }
            },
            
            toggleSelected1(index) {
                this.objArr.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.useobj = item.key
                        console.log('选中的值1为：', item.value);
                    } else {
                        item.selected = false;
                    }
                });
            },
            toggleSelected2(index) {
                this.zzArr.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        console.log('选中的值2为：', item.value);
                        this.tempform.zhuangj = item.key
                    } else {
                        item.selected = false;
                    }
                });
            },
            toggleSelected3(index) {
                this.readbooktype.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.goodsType = item.value
                        console.log('选中的值3为：', item.value);
                    } else {
                        item.selected = false;
                    }
                });
            },
            toggleSelected4(index) {
                this.Paymentmethod.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.delivery = item.value
                        console.log('选中的值4为：', item.value);

                    } else {
                        item.selected = false;
                    }
                });
            },
            toggleSelected6(index) {
                this.listingstatus.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.delivery = item.value
                        console.log('选中的值4为：', item.value);

                    } else {
                        item.selected = false;
                    }
                });
            },
            
            toggleSelected5(index) {
                this.specialsubjectArr.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.activitytag = item.value
                        console.log('选中的值4为：', item.value);

                    } else {
                        item.selected = false;
                    }
                });
            },
            handleSelectChange(value) {
                this.form.status = value
                console.log('当前选中的值是：', value);
            },
            //弹开收起
            toggleSlide(s) {
                // let vm = this,
                //     div = document.getElementById('search_top_con');
                // div.style.transition = 'height ' + s + 'ms';
                // vm.dropdown = !vm.dropdown;
                // if (vm.dropdown) vm.H = `560px`; else vm.H = `25px`
                this.toggleAdditionalSearch(s)
            },
            toggleAdditionalSearch(s) {
               let vm = this,
                div = document.getElementById('search_top_con');
                div.style.transition = 'height ' + s + 'ms';
            this.showAdditionalSearch = !this.showAdditionalSearch;
            if (this.showAdditionalSearch) this.H=`650px` ; else this.H = `300px`
            },
            zajindan(){
                this.isBeat = true;
            },
            iSlogin() {
                return Cookies.get('token') ? true : false;
            },
            //检索
            onSubmit() {
                let vm = this,
                    queryFormData = {};
                queryFormData = JSON.parse(JSON.stringify(vm.tempform));
                let isbns = queryFormData.isbns,
                    activitytag = queryFormData.activitytag;
                    console.log(activitytag,'activitytagactivitytag');
                if (isbns && isbns != '') queryFormData.isbns = isbns.replace(/-/g, '');
                queryFormData.activitytag = activitytag ? (Array.isArray(activitytag) ? activitytag : [activitytag]).join(',') : '';
                delete queryFormData.subjectShow;
                delete queryFormData.dazhongshow;
                let doId = +localStorage.getItem('doId') + 1;
                localStorage.setItem('doId', doId);
                insertPoint(queryFormData, 'click', 'search', doId); //添加“高级检索”埋点

                vm.$emit('submitForm', queryFormData);
            },
            //清除
            clearValue(prop, val, data) {
                let vm = this;
                vm.tempform[prop] = null;
                if (val) vm[val] = null;
                if (data) vm.tempform[data] = null;
            },
            //重置
            resetForm() {
                let vm = this;
                vm.classifydata = null;
                vm.xuekedata = null;
                vm.dazhongdata = null;
                vm.tempform.xkfl = null;
                vm.tempform.dzfl = null;
                vm.tempform.pubid = null;
                vm.tempform.isbns = null;
                vm.tempform.bookname = null;
                vm.tempform.myfrom = null;
                vm.tempform.myto = null;
                vm.tempform.author = null;
                vm.tempform.pubname = null;
                vm.tempform.ztf = null;
                vm.tempform.subjectShow = null;
                vm.tempform.dazhongshow = null;
                vm.tempform.pubfrom = null;
                vm.tempform.pubto = null;
                vm.tempform.min = null;
                vm.tempform.max = null;
                this.objArr.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.useobj = item.key
                    } else {
                        item.selected = false;
                    }
                });
                this.zzArr.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.zhuangj = item.key
                    } else {
                        item.selected = false;
                    }
                });
                this.Paymentmethod.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.delivery = item.value


                    } else {
                        item.selected = false;
                    }
                });
                 this.listingstatus.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.delivery = item.value


                    } else {
                        item.selected = false;
                    }
                });
                this.readbooktype.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.goodsType = item.value

                    } else {
                    }
                });
                this.specialsubjectArr.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.activitytag = item.value

                    } else {
                    }
                });
                console.log(vm.tempform, 'vm.tempform重置');
                // vm.$refs.tempform.resetFields();
            },
            //中图法
            ztfflWindow() {
                let vm = this;
                vm.m_modal = popup('<classify-pop @close="close" @ok="submit" :msg="msg"/>', {
                    option: {
                        title: '中图法分类',
                        width: '800px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.classifydata
                            }
                        },
                        components: {
                            classifyPop
                        },
                        methods: {
                            submit(data) {
                                let str = String(data.msgCode);
                                vm.$set(vm.tempform, 'ztf', str);
                                vm.classifydata = data.dataStr;
                                vm.m_modal.hide();
                            },
                            close(data) {
                                vm.m_modal.hide();
                            }
                        }
                    }
                });
                vm.m_modal.show();
            },
            //学科分类
            styClass() {
                let vm = this;
                vm.sty_clsss = popup('<studyclass @close="close" @ok="submit" :msg="msg"/>', {
                    option: {
                        title: '学科分类',
                        width: '630px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.xuekedata
                            }
                        },
                        components: {
                            studyclass
                        },
                        methods: {
                            submit(data) {
                                vm.xuekedata = data;
                                let arr = data.split('|');
                                vm.tempform.subjectShow = arr[1];
                                vm.tempform.xkfl = arr[0];
                                vm.sty_clsss.hide();
                            },
                            close(data) {
                                vm.sty_clsss.hide();
                            }
                        }
                    }
                });
                vm.sty_clsss.show();
            },
            //大众分类
            pubClass() {
                let vm = this;
                vm.public_clsss = popup('<publicpop @close="close" @ok="submit" :msg="msg" :search="0" :datatype="3"/>', {
                    option: {
                        title: '大众分类',
                        width: '600px',
                        height: '560px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.dazhongdata
                            }
                        },
                        components: {
                            publicpop//中图组件
                        },
                        methods: {
                            submit(data) {
                                console.log(data,'大众分类');
                                vm.dazhongdata = data;
                                let arr = data.split('|');
                                vm.tempform.dazhongshow = arr[1];
                                vm.tempform.dzfl = arr[0];
                                vm.public_clsss.hide();
                            },
                            close(data) {
                                vm.public_clsss.hide();
                            }
                        }
                    }
                });
                vm.public_clsss.show();
            },
            //出版社
            pubpop() {
                let vm = this;
                vm.pub_pop = popup('<pub-dialog @close="close" :msg="msg" @ok="submit" />', {
                    option: {
                        title: '出版社选择',
                        width: '630px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.pubObjCheck
                            }
                        },
                        components: {
                            pubDialog
                        },
                        methods: {
                            submit(data) {
                                vm.tempform.pubname = data.pubname;
                                // console.log(vm.tempform.pubname,'vm.tempform.pubname')
                                // vm.tempform.pubid = data.pubid;
                                data.choosedData.forEach(element => {
                                    vm.pubObjCheck.push(element.orgName)
                                });
                                vm.pub_pop.hide();
                            },
                            close(data) {
                                vm.pub_pop.hide();
                            }
                        }
                    }
                })
                vm.pub_pop.show();
            },
            //关键词
            multiplePop(txt, flag) {
                let vm = this,
                    val = '';
                val = vm.tempform[flag];
                vm.key_pop = popup('<key-value-pop @close="close" @ok="submit" :msg="msg" />', {
                    option: {
                        title: `多个${txt}批量查询`,
                        width: '336px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: {
                                    val: val,
                                    flag: flag
                                }
                            }
                        },
                        components: {
                            keyValuePop
                        },
                        methods: {
                            submit(data) {
                                let flag = data.flag;
                                vm.tempform[flag] = data.val;
                                vm.key_pop.hide();
                            },
                            close() {
                                vm.key_pop.hide();
                            }
                        }
                    }
                })
                vm.key_pop.show();
            },

            //获取活动状态
            // getActiveStatue(now) {
            //     let vm = this,
            //         lastTime = new Date(
            //             vm.timelist[vm.timelist.length - 1].end
            //         ).getTime(); //活动最后一场时间戳
            // },
            zjdClose() {
                let vm = this;
                vm.isBeat = false;
                if (Cookies.get('token')) {
                    Axios.post('/gold/activate/ugetrecordlist', {
                        params: {
                            selecttj: 'gold_activate_record.user_id=' + Cookies.get("UserID"),
                            ordertj: '',
                            pageSize:100,
                            pageNum:1,
                            userid:Cookies.get("UserID"),
                            activateid:vm.activateid
                        }
                    }, {
                        headers: {
                            "Content-Type": "application/json",
                            token: Cookies.get('token')
                        }
                    }
                    ).then(res => {
                        if (res.status) {
                            if (res.data.list.length > 0) {
                                
                                vm.levels = res.data.list[0].level
                                 vm.present_name = res.data.list[0].present_name
                                if( vm.levels == '4等奖'){
                                    vm.ishuode = false
                                }else{
                                    vm.ishuode = true
                                }
                                vm.newRecodePop = true; //显示中奖纪录
                                vm.stopScroll()
                                vm.newRecodePop = true; //显示中奖纪录
                                vm.dianclose = true
                            } else {
                                vm.stopScroll()
                                
                                vm.newRecodePop = false; 
                                vm.dianclose = false

                            }
                        }
                    }).catch(err => {

                    });
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            //获取举行砸金蛋活动的供应商（出版社）信息
            // getNowActiveInfo() {
            //     let vm = this;
            //     if (Cookies.get("token")) {
            //         Axios.post("/gold/activate/getnowactivate", {
            //             params: {
            //                 userid: Cookies.get("UserID"),
            //             },
            //         }, {
            //             headers: {
            //                 "Content-Type": "application/json",
            //                 token: Cookies.get("token"),
            //             },
            //         }).then((res) => {
            //             if (res.status) {
            //                 //判断是否是供应商列表页面，且是当前供应商（出版社）
            //                 if (vm.$route.query.obj) {
            //                     let rp = JSON.parse(vm.$route.query.obj);
            //                     //是否为出版社(供应商)书目列表页面
            //                     if (
            //                         vm.$route.name ==
            //                         "LookPublishingPagesType" &&
            //                         rp[res.data.datatype] == res.data.org_name
            //                     ) {
            //                         //如果是
            //                         if (rp.gid != "0") {
            //                             if (res.data.isjoin == 0) {
            //                                 vm.isBeat = true;
            //                                 vm.isjieguo = false;
            //                             } else {
            //                                 vm.isjieguo = true;
            //                                 vm.isBeat = false;
            //                             }
            //                         }
            //                         if (rp.isHandleBeat == "0") {
            //                             vm.isjieguo = true;
            //                             vm.isBeat = false;
            //                         }
            //                     } else {
            //                         //否则跳转到 出版社(供应商)书目列表页面LookPublishingPagesType
            //                         let params = {
            //                             isHandleBeat: 1, //是否是点击“砸金蛋”进入标识
            //                             goodsType: 1,
            //                             eventId: "ad1000",
            //                         };
            //                         params[res.data.datatype] =
            //                             res.data.org_name;
            //                         vm.$router.push({
            //                             name: "LookPublishingPagesType",
            //                             query: { obj: JSON.stringify(params) },
            //                         });
            //                     }
            //                 } else {
            //                     //否则跳转到 出版社(供应商)书目列表页面LookPublishingPagesType
            //                     let params = {
            //                         isHandleBeat: 1, //是否是点击“砸金蛋”进入标识
            //                         goodsType: 1,
            //                         eventId: "ad1000",
            //                     };
            //                     params[res.data.datatype] = res.data.org_name;
            //                     vm.$router.push({
            //                         name: "LookPublishingPagesType",
            //                         query: { obj: JSON.stringify(params) },
            //                     });
            //                 }
            //                 //获取活动id
            //                 vm.activateInfo = res.data;
            //             } else {
            //                 if (res.code == "1000") {
            //                     vm.$alert(res.msg, "温馨提示", {
            //                         confirmButtonText: "确定",
            //                     });
            //                 } else if (res.code == "2000") {
            //                     let params = {
            //                         isHandleBeat: 0, //是否是点击“砸金蛋”进入标识
            //                         goodsType: 1,
            //                         eventId: "ad1000",
            //                     };
            //                     params[res.data.datatype] = res.data.org_name;
            //                     vm.$router.push({
            //                         name: "LookPublishingPagesType",
            //                         query: { obj: JSON.stringify(params) },
            //                     });
            //                 }
            //             }
            //         }).catch((err) => {
            //             vm.$alert(err.msg, "温馨提示", {
            //                 confirmButtonText: "确定",
            //             });
            //         });
            //     } else {
            //         this.$router.push({ name: "Login" });
            //     }
            // },

            //查询中奖纪录
           async getWinningRecord() {
                let vm = this;
                if (Cookies.get('token')) {
                    // 查询活动场次
                    let data = {
                     userid:Cookies.get('UserID'),
                     orgid: vm.activityID
                    }
                    let res = await goldeggsids(data)
                    if(res.code == '200'){
                        if(res.data.length>0){
                        vm.huodongchangci = res.data
                        for(let i= 0 ; i < vm.huodongchangci.length; i++){
                            if(vm.huodongchangci[i].org_id == vm.activityID ){
                            vm.activatesource = vm.huodongchangci[i].org_name
                            vm.activateid = vm.huodongchangci[i].activate_id
                            const startDate = new Date(vm.huodongchangci[i].start_time);
                            const endDate = new Date(vm.huodongchangci[i].end_time);
                            const currentDate = new Date(); 
                            if (currentDate >= startDate && currentDate <= endDate) {
                            this.showactivity = true
                            Axios.post('/gold/activate/ugetrecordlist', {
                            params: {
                            selecttj: 'gold_activate_record.user_id=' + Cookies.get("UserID"),
                            ordertj: '',
                            pageSize:100,
                            pageNum:1,
                            userid:Cookies.get("UserID"),
                            activateid:vm.activateid
                        }
                    }, {
                        headers: {
                            "Content-Type": "application/json",
                            token: Cookies.get('token')
                        }
                    }
                    ).then(res => {
                        if (res.status) {
                            if (res.data.list.length > 0) {

                                vm.levels = res.data.list[0].level
                                 vm.present_name = res.data.list[0].present_name
                                if( vm.levels == '4等奖'){
                                    vm.ishuode = false
                                }else{
                                    vm.ishuode = true
                                }
                                vm.newRecodePop = true; //显示中奖纪录
                            } else {
                                vm.startTimer()
                                vm.newRecodePop = false; //显示中奖纪录
                            }
                           }
                          }).catch(err => {});
                        } else if (currentDate < startDate) {
                            this.showzajindan = true
                            // this.showactivity = false
                            this.showstart = true
                         vm.starttimekaishi = this.formatTimestamp(vm.huodongchangci[i].start_time) 
                        // return "未开始";
                        } else {
                        vm.showzajindan = true
                        // vm.showactivity = false
                        vm.showstart = false
                        // return "已结束";
                        }
                    }else{
                        return vm.showzajindan = false
                    } 
                    }
                    } else{
                        return vm.showzajindan = false
                    }
                    }else{
                        vm.$message({
                          message: res.msg,
                          type: 'error'
                        }); 
                        return vm.showzajindan = false

                    }
                          
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
        formatTimestamp(timestamp) {
         const dateObj = new Date(timestamp);
         const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
         const day = dateObj.getDate().toString().padStart(2, '0');
         const time = timestamp.split(' ')[1];
           return `${month}-${day} ${time}`;
       },
            // 查询中奖记录
            getJindan() {
                Axios.post('/gold/activate/ugetrecordlist', {
                    params: {
                        selecttj: 'gold_activate_detail.level<4',
                        ordertj: '',
                        pageSize:100,
                        pageNum:1,
                        userid:Cookies.get('UserID'),
                    }
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        token: Cookies.get('token')
                    }
                }
                ).then(res => {
                    let data = {
                        names: res.org_name
                    }
                    for (var i in res.data.list)
                        this.listname.push({
                            org_name:res.data.list[i].org_name,
                            level:res.data.list[i].level
                        })

                })
            },
            // 跳转到领取页面
            getWinning() {
                this.$router.push({ name: "myPrice" })
            }

        }
    };
</script>

<style lang='scss'>
.supply_wrap2{
    .search-box1 {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0 15px 15px 15px;
        margin: 0 auto;
    }

    .suppldetaibox-top {
        width: 95%;
        margin: 25px auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .flex-container {
        display: flex;
        flex-wrap: wrap;
    }

    .flex-item {
        flex: 0 0 calc(8.14% - 10px);
        /* 每个元素占据约 7.14% 的宽度，减去间隔 */
        margin: 5px;
        /* 设置元素间隔 */
        text-align: center;
        /* 文字居中显示 */
        cursor: pointer;
        font-weight: 400;
        line-height: 30px;
        /* 鼠标指针样式为手型 */
    }

    .selected {
        background-color: lightblue;
        font-weight: 700;
        /* 设置选中样式，可以根据需要调整 */
    }

    .el-form-item__content {
        line-height: 30px !important;
        font-size: 14px;
    }

    .suppldetaibox {
        margin: 0 auto;
        width: 80%;
        /* height: 3000px; */
        background-color: #b82830;
    }

    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    .mySelect {
        width: 100px;
    }

    .search-wrap {
        background-color: #fff;
        position: relative;
        overflow: hidden;

        .drop_btn {
            position: absolute;
            display: block;
            line-height: 30px;
            padding: 0px 40px;
            cursor: pointer;
            bottom: 0px;
            right: 0px;
            color: #999;
        }

        .no-margin {
            margin: 0 !important;
        }

        /* .el-input {
            width: 192px;
        } */

        .el-input__inner {
            /* padding: 0px 8px; */
            height: 35px;
            /* width: 192px; */
        }

        .s-input {
            float: left;
            width: 75px;

            .el-form-item__content {
                .midbox {
                    width: 52px;
                }
            }

            .el-input__inner {
                padding: 0px 8px;
                width: 52px;
            }
        }

        .date-input {
            float: left;
            width: 130px;

            .el-input__inner {
                padding: 0px 8px;
                width: 128px;
            }
        }

        .el-input--prefix .el-input__inner {
            padding-left: 25px;
        }

        .line {
            text-align: center;
        }

        .s-input {
            .el-input {
                width: 70%;
            }

            i {
                font-style: normal;
            }
        }

        .el-form-item__label {
            padding-right: 5px;
            font-size: 12px;
        }

        .search-btn {
            text-align: center;
            padding-top: 15px;
        }

        //表单清除
        .labelwrap {
            position: relative;

            .circleclose {
                display: none
            }

            .el-form-item__content:hover .circleclose {
                position: absolute;
                cursor: pointer;
                top: 3px;
                right: 0px;
                height: 24px;
                line-height: 24px;
                width: 24px;
                text-align: center;
                color: #bcc0c5;
                display: block;
            }
        }
    }

    /* 分类弹框样式 */
    .cont-sty {

        //学科、大众
        .el-col .treebox {
            width: 209px;
            height: 323px;
            padding: 15px 0 0 15px;
            padding-right: 0px;
            margin: 28px 0 0 38px;
            background-color: #fff;
            border-radius: 4px;
            border: solid 1px #c9d7e8;

            .search-sty {
                .el-input__inner {
                    width: 200px;
                    height: 32px;
                    padding-left: 28px;
                    background-color: #fff;
                    border-radius: 16px;
                    height: 28px;
                    line-height: 28px;
                    border: solid 1px #b6d2e6;
                }

                .el-icon-search {
                    line-height: 32px;
                }
            }

            .lefttree {
                height: 291px;
                overflow: auto;
                list-style: none;

                .check-box {
                    cursor: pointer;
                    margin-top: 10px;
                }
            }

            .tit {
                font-weight: bold;
                font-size: 13px;
            }

            .right-tree {
                width: 209px;
                height: 301px;
                overflow: auto;
                list-style: none;
                padding: 0px;

                >li {
                    cursor: pointer;
                    margin-top: 10px;

                    span {
                        display: inline-block;
                        width: 170px;
                        font-size: 12px;
                    }

                    i {
                        font-size: 17px;
                        color: #bbc8d4;
                    }

                    &:hover i {
                        color: #1c7bd3;
                    }
                }

                >li:hover {
                    color: #1c7bd3;
                }
            }

            .noData {
                text-align: center;
                font-size: 12px;

                img {
                    height: 90px;
                    width: 70px;
                    margin: 30px auto 15px;
                    display: block;
                }

                .p {
                    margin: 4px;
                }
            }

        }
    }

    .clearbtn {
        float: right;
        margin-right: 18px;
        width: 47px;
        height: 22px;
        line-height: 22px;
        background-color: #ffeaea;
        border-radius: 2px;
        border: 1px solid #f2c3c3;
        color: #ce4747;
    }

    .btnbase {
        border: 0px;
        // border-radius: 50px;
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;
        // padding:0 24px;
        display: inline-block;
        height: 33px;
        line-height: 33px;
        margin: 8px 12px;
        width: 70px;
        background-color: #deefff;
        border-radius: 4px;
    }

    .btn_box {
        //按钮样式
        text-align: center;
        margin-top: 15px;

        .btn_sure {
            @extend .btnbase;
            color: #fff;
            background-color: #2c88f4;
        }

        .btn_canle {
            @extend .btnbase;
            color: #2c88f4;
            background-color: #deefff;
        }

        .btn_green {
            @extend .btnbase;
            color: #fff;
            background-color: #67c23a;
        }
    }



    .zjd {
        margin: 30px auto;
        height: 700px;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .zjdBg {
        /* 
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    // background: rgba(235, 228, 228 / 80%);
    z-index: 100;
    overflow-y: hidden; */

        .zjdContent {
            height: 100%;
            color: #fff;

            .supplier {
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: cadetblue;
            }

            .nextTime {
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: #fb7d0f;
            }

            .activityContent {
                // display: flex;
                height: 100%;

                .Sessions {
                    width: 100%;
                    height: 100%;
                    line-height: 50px;
                    text-align: center;
                    // background-color: aquamarine;
                }
            }
        }
    }

    .zjdClose {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 20px;
        right: 20px;
        cursor: pointer;
        z-index: 109;

        img {
            width: 30px;
            height: 30px;
        }
    }

    .zjdBox {
        width: 420px;
        height: 520px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
    }

    .Sign {
        height: 300px;
        text-align: center;
        display: flex;
        padding: 0;
        flex-direction: column;
        justify-content: space-around;
        color: #000;

        .success {
            font-size: 22px;
        }

        .continuity {
            font-size: 25px;
        }

        .el-button {
            margin-bottom: 50px;
        }

        p {
            text-align: left;
            display: flex;
            justify-content: center;
        }
    }

    .zjdGet {
        position: fixed;
        top: 20px;
        left: 20px;
        background: rgba(0, 0, 0, 0.3);
        width: 90px;
        // height: 120px;
        text-align: center;
        cursor: pointer;
        z-index: 99;
    }

    .zjdimg img {
        width: 60px;
    }

    .zjdtext {
        color: #fff;
        font-size: 12px;
        line-height: 30px;

        >b {
            font-weight: normal;
        }
    }

    .TopComStyle {
        position: relative;
        height: 60px;
        width: 100%;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: undefined, inset 0px -1px 0px 0px rgba(0, 0, 0, 0.08);

        .el-dropdown {
            cursor: pointer;
        }
    }

    .topContainer {
        width: 1200px;
        height: 100%;
        margin: 0px auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: white;
    }

    /* 1 */
    .topConLeft {
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 17px;
        cursor: pointer;
    }

    .topConLeft img {
        width: 150px;
        height: 55px;
    }

    .topConLeft span {
        cursor: pointer;
        color: #666;
        font-size: 16px;
        margin-left: 25px;
        padding: 0px 3px;
        line-height: 30px;
    }

    .topConLeft span.cur {
        // color: #fb7d0f;
        border-bottom: 3px solid #fb7d0f;
    }

    /* 2 */
    .el-input {
        /* width: 250px; */
        text-align: left;
        font-family: PingFangSC-Regular;
    }

    .topContainer>>>.el-input__inner {
        color: rgba(0, 0, 0, 0.25);
        font-size: 14px;
    }

    /* 3 */
    .TopConRight {
        color: black;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
    }

    .TopConRight>span {
        margin-left: 15px;
    }

    .q {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .r {
            margin: 0 auto;
        }

        .r div {
            width: 375px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background-color: yellowgreen;
            border: 1px solid #000;
            font-size: 20px;
        }

        // .zjdBox {
        //     width: 500px;

        //     background-color: #fff;
        // }

        .hdcc {
            width: 150px;
            height: 30px;
            background-color: #63000f;
            border-radius: 30px;
            line-height: 30px;
            text-align: center;
            margin: 0 auto;
        }

        .prInfo {
            position: absolute;
            top: 80px;
            right: 35px;
            width: 330px;
            height: 430px;
            background-color: #fff;
            border-radius: 10px;
        }
        .prInfo-box{
            width: 100%;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-top-left-radius: 10px; 
            border-top-right-radius: 10px; 
            background-color: #63000f;
        }
            
                                

        .prInfo-info {
            width: 150px;
            height: 30px;
            background-color: #63000f;
            border-radius: 30px;
            margin: 10px auto;
            line-height: 30px;
            text-align: center;

        }

        .notice {
            width: 270px;
            height: 300px;
            border-radius: 8px;
            // border: 1px solid #eee;

        }

        .notice__inner {
            width: 100%;
            height: 100%;
            overflow: hidden;
            font-size: 14px;
            color: #999;
        }

        .notice__box {
            animation: roll 2s linear infinite;
        }

        .notice__item {
            width: 100%;
            height: 100px;
            line-height: 100px;
            padding: 0 12px;
            overflow: hidden;
            text-align: center;
            white-space: nowrap;
        }

        @keyframes roll {
            0% {
                transform: translatey(0);
            }

            100% {
                transform: translatey(-300px);
            }
        }

        .zjdtime {
            font-size: 24px;
            position: absolute;
            top: 0;
            left: 0;
        }

        .hdcc1 {
            width: 300px;
            height: 400px;
            background-color: pink;
            position: absolute;
            top: 80px;
            left: 35px;
        }

        .hdcc1 div {
            width: 342px;
            height: 40px;
            border: 1px solid #fff;
            line-height: 40px;
            text-align: center;
        }


      

        .lottery-alerth1 {
            font-size: 20px;
            font-weight: 400;
            color: #000;
            position: relative;
            // margin-top: 20px;
        }

        .zjdContainer {
            font-family: Avenir, Helvetica, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-align: center;
            color: #666;
            background-color: #bd2a33;
            height: 100%;
            width: 100%;
        }

        .zjdtitle {
            position: absolute;
            top: 20px;
            width: 100%;
            text-align: center;
        }

        .myprize {
            -moz-border-radius: 20px;
            border-radius: 20px;
            padding: 8px 20px;
            color: #edd251;
            font-weight: bold;
            font-size: 18px;

            margin: auto;
            // background: #fff;
        }

        .myprizeimg {
            width: 260px;
            height: 260px;
            background-color: pink;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: 120px;
            bottom: 90px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .myprizetitle {
            position: absolute;
            bottom: 45px;
            left: -5%;
            width: 150px;
            height: 30px;
            border-radius: 30px;
            border: 1px solid #999;
            text-align: center;
            line-height: 30px;
            margin-left: 200px;
        }

        .linqu {
            position: absolute;
            bottom: 0;
            left: 37%;
            width: 100px;
            height: 30px;
            border-radius: 30px;
            border: 1px solid #999;
            text-align: center;
            line-height: 30px;
            margin-bottom: 1px;
            cursor: pointer;
        }

        .nostate {
            width: 500px;
            height: 100px;
            // border: 1px solid #fff;
            line-height: 100px;
            text-align: center;
            font-size: 38px;
            position: absolute;
            left: 30%;
            top: 36%;
        }

    }


    ul {
        list-style: none;
    }

    a img {
        border: none;
    }

    a {
        color: #333;
        text-decoration: none;
    }

    a:hover {
        color: #ff0000;
    }

    #mooc {
        width: 399px;
        border: 5px solid #ababab;
        border-radius: 15px;
        box-shadow: 2px 2px 10px #ababab;
        margin: 50px auto 0;
        text-align: left;
        height: 300px;
        /* 增加整体高度 */
    }

    #moocTitle {
        height: 62px;
        overflow: hidden;
        font-size: 26px;
        line-height: 62px;
        padding-left: 30px;
        background-image: linear-gradient(top, #f05e6f, #c9394a);
        border: 1px solid #f05e6f;
        border-radius: 8px 8px 0 0;
        color: #fff;
        position: relative;
    }

    #moocTitle a {
        position: absolute;
        right: 10px;
        bottom: 10px;
        display: inline;
        color: #fff;
        font-size: 12px;
        line-height: 24px;
    }

    #moocBox {
        height: 335px;
        /* 增加内容区域高度 */
        margin-top: 15px;
        overflow: hidden;
        height: 360px;
        margin-left: 10px;
        margin-right: 10px;

    }

    #mooc ul li {
        height: 40px;
        /* 增加单行高度 */
        line-height: 40px;
        /* 设置行高 */
    }

    #mooc ul li a {
        width: 180px;
        float: left;
        display: block;
        overflow: hidden;
        text-indent: 15px;
        height: 40px;
    }

    #mooc ul li span {
        float: right;
        color: #999;
    }
    .bottxtx{
        font-size: 16px;
        display: block !important;
        /* margin-left: 4%; */
        text-align: center;
        color: #63000f;
        font-weight: 700;
    }
   @keyframes jump {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-8px); }
    }

    .jump-text {
        display: inline-block;
        animation: jump 2s infinite;
        color: #FFD700;
    }
    }
</style>


// WEBPACK FOOTER //
// src/components/SearchComponentcopy.vue